import { IconProps } from 'src/utils/icon';

const EditIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 14"
  >
    <path
      fill={fill}
      d="M11.183 2.273L13.69 4.74a.265.265 0 010 .377L7.622 11.09l-2.578.282a.536.536 0 01-.597-.588l.286-2.538L10.8 2.273a.275.275 0 01.383 0zm4.5-.627L14.328.312a1.099 1.099 0 00-1.534 0l-.983.968a.265.265 0 000 .377l2.506 2.467a.275.275 0 00.383 0l.983-.968a1.058 1.058 0 000-1.51zm-5.016 7.82v2.784h-8.89V3.498h6.384a.344.344 0 00.236-.096l1.111-1.094c.211-.208.061-.56-.236-.56H1.333C.597 1.748 0 2.336 0 3.06v9.627C0 13.412.597 14 1.333 14h9.778c.736 0 1.333-.588 1.333-1.313V8.372c0-.293-.358-.438-.569-.233l-1.111 1.094a.334.334 0 00-.097.233z"
    />
  </svg>
);

export default EditIcon;
